// src/features/security/components/SecurityPolicyCard.tsx
import { Card } from '../../../app/components/foundation';
import type { SecurityPolicy } from '../data/security.mock';
import { SecurityStatusBadge } from './SecurityStatusBadge';

export interface SecurityPolicyCardProps {
  policy: SecurityPolicy | undefined;
}

/**
 * Workspace card: this module's policy — name, status, and its rule
 * list. `policy` comes from useSecurityWorkspaceMock. Same field-list
 * + list markup as customers/components/CustomerInfoCard.tsx (fields)
 * combined with customers/components/CustomerServicesCard.tsx (list).
 */
export function SecurityPolicyCard({ policy }: SecurityPolicyCardProps) {
  return (
    <Card className="vania-security-workspace-card">
      <h2 className="vania-security-workspace-card-title">سیاست امنیتی</h2>

      {!policy ? (
        <p className="vania-security-workspace-empty">سیاستی برای این ماژول ثبت نشده است.</p>
      ) : (
        <>
          <dl className="vania-security-workspace-fieldlist">
            <div>
              <dt>نام سیاست</dt>
              <dd>{policy.name}</dd>
            </div>
            <div>
              <dt>وضعیت</dt>
              <dd>
                <SecurityStatusBadge status={policy.status} />
              </dd>
            </div>
          </dl>

          {policy.rules.length === 0 ? (
            <p className="vania-security-workspace-empty">قانونی برای این سیاست ثبت نشده است.</p>
          ) : (
            <ul className="vania-security-workspace-list">
              {policy.rules.map((rule) => (
                <li key={rule} className="vania-security-workspace-list-item">
                  <span className="vania-security-workspace-list-primary">{rule}</span>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </Card>
  );
}
